import type { ReactNode } from "react";

import { LocalOverlayContext, useLocalOverlay } from "context/localOverlayContext";
import { createPortal } from "react-dom";

type TLocalPortalProps = {
  children: ReactNode;
  escapeOverlay?: boolean;
  parentContainer?: HTMLElement | null;
};

export const LocalPortal: FC<TLocalPortalProps> = ({ children, escapeOverlay = false, parentContainer }) => {
  const overlay = useLocalOverlay();
  const target = escapeOverlay ? null : overlay;

  return createPortal(
    <LocalOverlayContext.Provider value={parentContainer ?? null}>
      {children}
    </LocalOverlayContext.Provider>,
    target ?? document.body,
  );
};
